// v2/hooks/useProfile.js — GET /api/profile/  (oturum sahibinin kisisel bilgileri)
// Doner: {ad_soyad, mail, gorev, meslek, dahili_no, cep_telefonu, dogum_tarihi}
import { useCallback, useEffect, useState } from 'react';
import { apiGet } from '../utils/api';

export default function useProfile() {
  const [profil, setProfil] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const yenile = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const veri = await apiGet('/profile/');
      setProfil((veri && veri.user) || null);
    } catch (e) {
      setError((e && e.message) || 'Profil bilgileri alınamadı');
      setProfil(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { yenile(); }, [yenile]);

  return { profil, loading, error, yenile };
}
